
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {optionsVslim} from '@/config/v-slim-dialog'
import {required} from 'vuelidate/lib/validators'
import {validationMixin} from 'vuelidate'
import {isFrenchMobileNumber} from '@/helpers'

const authModule = namespace('auth')
const prospectModule = namespace('prospect')
const smsModule = namespace('sms')

@Component({
  components: {},
  mixins: [validationMixin],
  validations: {
    contentTextArea: {
      required
    }
  }
})
export default class SmsBuilderPanel extends Vue {
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @smsModule.Action('sendSmsAction') sendSms: any
  @smsModule.Action('getSmsBlocTextsAction') getSmsBlocTexts: any
  @smsModule.Getter('smsBlocTextsGetter') smsBlocs: any
  @smsModule.Action('getServiceNameSmsAction') getServiceNameSms: any
  @smsModule.Getter('smsCreditsLeftGetter') smsCreditsLeft: any
  @authModule.Getter('meGetter') me: any
  @Prop(Array) prospects!: any

  smsSelected = ''
  contentTextArea = ''
  countContentTextArea = 0
  isLoading = false
  contacts = []
  desti = []
  stopSms = false

  get alertClassCredits() {
    if (this.smsCreditsLeft < 10) {
      return 'alert-danger'
    }
    if (this.smsCreditsLeft < 20) {
      return 'alert-warning'
    }
    return 'alert-info'
  }

  get canSendSms() {
    return this.smsCreditsLeft > 0
  }

  get maxLength() {
    return this.stopSms ? 150 : 160
  }

  getTelephone(contact) {
    if (contact.TELEPHONE1 && isFrenchMobileNumber(contact.TELEPHONE1)) {
      return contact.TELEPHONE1
    }
    if (contact.TELEPHONE2 && isFrenchMobileNumber(contact.TELEPHONE2)) {
      return contact.TELEPHONE2
    }
    return null
  }

  mounted() {
    this.contacts = this.prospects.map((prospect) => prospect.CONTACTS).flat()
    const contactsAllowed = this.contacts.filter((contact) => this.getTelephone(contact))
    this.desti = contactsAllowed.map((contact) => this.getTelephone(contact))
    this.getSmsBlocTexts()
    this.getServiceNameSms()
  }

  @Watch('smsSelected', {deep: false})
  watchSmsSelected(val: any) {
    this.contentTextArea = val
  }

  @Watch('contentTextArea', {deep: false})
  watchContentTextArea(val: any) {
    this.countContentTextArea = val.length
  }

  async sendSmsHandler(id: number) {
    this.$v.$touch()
    if (!this.$v.$invalid) {
      if (this.desti.length !== 0) {
        const {ok} = await this.$dialogs.confirm(
          `Confirmez l'envoi du sms à ${this.desti.join(', ')}` + ' ?',
          optionsVslim
        )
        if (ok) {
          this.isLoading = true
          this.sendSms({
            MESSAGE: this.contentTextArea,
            RECEIVERS: this.desti,
            ID_CONSEILLER: this.me.ID,
            STOP_SMS: this.stopSms
          })
            .then(async (data) => {
              if (this.prospects.length === 1) await this.getProspectById(this.prospects[0].ID)
              this.isLoading = false
              this.onCloseHandler()
            })
            .catch(() => {
              this.isLoading = false
            })
        }
      } else {
        Vue.notify({
          group: 'user',
          type: 'warn',
          title: 'Attention',
          text: 'Aucun destinataire sélectionné'
        })
      }
    } else {
      // ScrollTop
      const panel: any = document.querySelector('.slideout')
      if (panel) panel.scrollTop = 0
    }
  }

  onCloseHandler() {
    this.$emit('closePanel', {})
  }
}
